import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { PaginacaoLoadingService } from '../service/paginacao-loading.service'

@Injectable()
export class PaginacaoLoadingInterceptor implements HttpInterceptor {
  private readonly loading = inject(PaginacaoLoadingService)

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!isPaginacaoRequest(request)) {
      return next.handle(request)
    }

    return new Observable((subscriber) => {
      this.loading.iniciar()
      const subscription = next.handle(request).subscribe(subscriber)
      return () => {
        subscription.unsubscribe()
        this.loading.finalizar()
      }
    })
  }
}

export function isPaginacaoRequest(request: HttpRequest<unknown>): boolean {
  if (request.method !== 'GET') {
    return false
  }

  if (request.params.has('page') && request.params.has('pageSize')) {
    return true
  }

  const url = request.urlWithParams
  if (/[?&]page=/.test(url) && /[?&]pageSize=/.test(url)) {
    return true
  }

  return isListagemPlanilhaRequest(url)
}

function isListagemPlanilhaRequest(url: string): boolean {
  const caminho = extrairCaminho(url)
  return /\/\d+\/linhas$/.test(caminho) || /\/\d+\/detalhado$/.test(caminho)
}

function extrairCaminho(url: string): string {
  const semQuery = url.split('?')[0]
  const semOrigem = semQuery.replace(/^https?:\/\/[^/?#]+/i, '')
  return semOrigem.replace(/\/+$/, '')
}
